<template lang="pug">
  .wrapper
    .title {{ detail.title }}
    .info.light
      .time {{ detail.timestamp }}
      .history-event 该事件历史发生
        span.theme {{ detail.count || 1 }}
        | 次
    .brief {{ detail.brief }}
    stock-relate(:list="detail.stock_list" v-if="type==='hot'||type==='marco'")
    stock-rank(:list="detail.best_stocks" v-else @jumpStockDetail="jumpStockDetail")
</template>

<script>
import StockRank from '@components/stock_rank.vue'
import StockRelate from '@components/stock_relate'

export default {
  components: {
    StockRank,
    StockRelate
  },
  props: {
    detail: Object,
    type: String,
    pathName: String
  },
  data() {
    return {
      id: ''
    }
  },
  methods: {
    // 个股详情数据处理跳转
    jumpStockDetail(id) {
      const detail = this.detail
      const stockDetail = {
        detail: detail.stock_list_detail.filter(item => item.id === id)[0],
        window_start: detail.window_start,
        window_end: detail.window_end,
        count: detail.count,
        event_list: detail.event_list
      }

      this.$store.dispatch('saveStockDetail', stockDetail)
      this.$router.push({
        name: this.pathName
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.wrapper
  padding 1rem
  box-sizing border-box
  min-height 100vh
  background-color #fff
  .title
    font-size 1.29rem
    line-height 2rem
    font-weight 600
  .info
    display flex
    padding 1rem 0
    font-size .86rem
    justify-content space-between
    .history-event
      .theme
        font-size .93rem
        font-weight bold
        padding 0 .29rem
   .brief
      line-height 1.71rem
      margin-bottom 1.43rem
</style>
